import { Injectable } from '@angular/core';
import { RuntimeConfig } from './runtime-config.model';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private config: RuntimeConfig | null = null;

  public async load(): Promise<void> {
    const response = await fetch('/assets/config.json', { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`Failed to load runtime config: HTTP ${response.status}`);
    }

    this.config = (await response.json()) as RuntimeConfig;
  }

  public get isLoaded(): boolean {
    return this.config !== null;
  }

  public get apiUrl(): string {
    return this.requireConfig().apiUrl;
  }

  public get appId(): string {
    return this.requireConfig().appId;
  }

  private requireConfig(): RuntimeConfig {
    if (!this.config) {
      throw new Error('Runtime config has not been loaded yet');
    }

    return this.config;
  }
}
